import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const EnvelopeIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 14"
  >
    <path
      fillRule="evenodd"
      d="M0 1.69C0 .757.76 0 1.697 0h12.606C15.24 0 16 .757 16 1.69v10.62c0 .933-.76 1.69-1.697 1.69H1.697A1.694 1.694 0 0 1 0 12.31zm1.455 0c0-.133.108-.242.242-.242h12.606c.133 0 .242.109.242.242V3.5L8 7.145 1.455 3.669zm13.09 3.62L8.342 8.604a.73.73 0 0 1-.684 0L1.455 5.31v7c0 .133.108.242.242.242h12.606a.24.24 0 0 0 .242-.242z"
      clipRule="evenodd"
    />
  </svg>
);
EnvelopeIcon.id = 'EnvelopeIcon';
EnvelopeIcon.displayName = 'EnvelopeIcon';
export default EnvelopeIcon;
